/**
 * Copy the value of a source input to a target input, and vice versa.
 * Handles both standard inputs and contenteditable elements.
 *
 * This helps to make a "textarea that resize with the input" as using a contenteditable div
 * resize according to its content without any js interaction.
 */
const hook = {
  mounted() {
    const targetId = this.el.getAttribute("phx-value-target");
    const placeholder = this.el.getAttribute("phx-value-placeholder");
    this.target = document.getElementById(targetId);

    if (!this.target) {
      console.warn(`TwoWayInputHook: target element #${targetId} not found`);
      return;
    }

    this.handleSourceChange = debounce(() => mirrorValue(this.el, this.target), 150);
    this.handleTargetChange = debounce(() => mirrorValue(this.target, this.el), 150);
    this.handlePlaceholder = () => setPlaceholder(this.target, placeholder);

    mirrorValue(this.el, this.target);
    this.handlePlaceholder();

    this.el.addEventListener("input", this.handleSourceChange);
    this.target.addEventListener("input", this.handleTargetChange);
    this.target.addEventListener("input", this.handlePlaceholder);

    this.handleEvent("petronille-set-message", ({ message }) => {
      this.el.value = message;
      mirrorValue(this.el, this.target);
      this.handlePlaceholder();
    });
  },
  destroyed() {
    if (this.target) {
      this.el.removeEventListener("input", this.handleSourceChange);
      this.target.removeEventListener("input", this.handleTargetChange);
      this.target.removeEventListener("input", this.handlePlaceholder);
    }
  },
};

const setPlaceholder = (element, placeholder) => {
  if (element.textContent == "") {
    element.style.setProperty("--placeholder-content", `"${placeholder}"`);
  } else {
    element.style.setProperty("--placeholder-content", '""');
  }
};

const mirrorValue = (source, target) => {
  const value = source.contentEditable == "plaintext-only" ? source.innerText : source.value;
  if (target.contentEditable == "plaintext-only") {
    target.innerText = value;
  } else {
    target.value = value;
  }
};

const debounce = (fn, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};

export default hook;
